import {Box, Item} from "devextreme-react/box";
import {SelectBox} from "devextreme-react/select-box";
import DateBox, {IDateBoxOptions} from "devextreme-react/date-box";
import Validator, {RequiredRule} from "devextreme-react/validator";
import {NativeEventInfo} from "devextreme/events";
import dxDateBox from "devextreme/ui/date_box";
import {useState} from "react";
import {getTimeframeByDate, getTimeframeByDescription, getTimeFrames, TimeframeType} from "../../utils/date-utils";
import './DateWithTimeframeBox.scss'

interface DateWithTimeframeBoxProps extends React.PropsWithChildren<IDateBoxOptions> {
	timeframeType: TimeframeType,
	timeRequired?: boolean
}

export default function DateWithTimeframeBox(props: DateWithTimeframeBoxProps) {

	let [date, setDate] = useState(props.value as Date);
	let [timeFrame, setTimeframe] = useState(getTimeframeByDate(props.value as Date, props.timeframeType)?.description);
	let testid = ((props.elementAttr !== undefined) && (props.elementAttr['data-testid'] !== undefined)) ? (props.elementAttr['data-testid'] + '-time') : undefined;

	return (
		<Box className="date-with-timeframe">
			<Item ratio={1}>
				<DateBox {...props}
					value={date}
					onValueChanged={(e) => {
						var previousValue = date;
						var newValue = e.value;
						setDate(newValue);
						if (!newValue)
							setTimeframe(undefined);

						props.onValueChanged && props.onValueChanged({ ...e, previousValue: previousValue, value: newValue });
					}}>
					{props.children}
				</DateBox>
			</Item>
			<Item ratio={1}>
				<SelectBox elementAttr={{ 'data-testid': testid }}
					className={props.timeRequired && !!date ? "required" : ""}
					readOnly={!date || props.readOnly}
					dataSource={getTimeFrames(props.timeframeType).map((x) => x.description)}
					value={timeFrame}
					onSelectionChanged={(e) => {
						var newValue = date;
						if (newValue)
							newValue.setHours(getTimeframeByDescription(e.selectedItem, props.timeframeType)?.start ?? 0);

						setDate(newValue);
						setTimeframe(e.selectedItem);

						props.onValueChanged && props.onValueChanged({ ...e, value: newValue } as NativeEventInfo<dxDateBox>);
					}}
					showClearButton={true}
				>
					<Validator>
						{
							props.timeRequired && !!date &&
							<RequiredRule message="Timeframe is required"></RequiredRule>
						}
					</Validator>
				</SelectBox>
			</Item>
		</Box>
	)
}
